<template>
    <div>
        <Batch v-for="item in items" :key="item.id" :data="item"/>
    </div>
</template>

<script>
    import Batch from './Batch'

    export default {
        name: 'BatchList',
        props: {
            items: Array
        },
        components: {
            Batch
        }
    }
</script>

<style scoped>

</style>